const GAMEPAD_ACTIVITY_EVENT = 'mousemove';
const GAMEPAD_ACTIVITY_THROTTLE_MS = 60_000;

let lastReplayActivityAt = Number.NEGATIVE_INFINITY;

/**
 * Emits a throttled DOM event so PostHog replay does not idle out during gamepad-only use.
 *
 * @param now - Timestamp used for throttling.
 */
export function markSessionReplayGamepadActivity(now = Date.now()): void {
  if (now - lastReplayActivityAt < GAMEPAD_ACTIVITY_THROTTLE_MS) {
    return;
  }

  if (typeof document === 'undefined') {
    return;
  }

  const event =
    typeof MouseEvent === 'function'
      ? new MouseEvent(GAMEPAD_ACTIVITY_EVENT, {
          bubbles: true,
          cancelable: false,
          ...(typeof window === 'undefined' ? {} : { view: window })
        })
      : new Event(GAMEPAD_ACTIVITY_EVENT, { bubbles: true, cancelable: false });

  document.dispatchEvent(event);
  lastReplayActivityAt = now;
}

/** Resets the module-level throttle for tests. */
export function resetSessionReplayGamepadActivityForTest(): void {
  lastReplayActivityAt = Number.NEGATIVE_INFINITY;
}
